import React, {PropTypes} from 'react';
import {Link} from 'react-router';

const RecipeList = ({recipes,collectionView,goToRecipe}) => {
	//console.log(collection);

	let recipeList = recipes.map(function(recipe){	
		let monthNames = ["January", "February", "March", "April", "May", "June",
		"July", "August", "September", "October", "November", "December"
		];			
		let coverImage = require('../../images/covers/cover_' + recipe.id + '.jpg');
		let pubDate = new Date(recipe.dateAdded);
		let pubMonth = monthNames[pubDate.getMonth()];
		let pubYear = pubDate.getFullYear();

		return (
		<div key={recipe.id} className="recipe-panel">
			<Link to={'/recipe/' + recipe.id} style={{backgroundImage: `url(${coverImage})`}} data-recipe={recipe.id} onClick={goToRecipe}>{recipe.title}</Link>
			<div className="recipe-panel-info">
				<div>
					<h4>{recipe.title}</h4>
					Chef: {recipe.firstName} {recipe.lastName}<br />
					Submitted: {pubMonth}, {pubYear}<br />
					Cuisine: Spanish
				</div>
			</div>
		</div>
		);
	});

	return(
		<div className={'recipe-list ' + collectionView}>
			{recipeList}
		</div>
	);
};

RecipeList.propTypes = {
	recipes: PropTypes.array.isRequired,
	collectionView: PropTypes.string.isRequired,
	goToRecipe: PropTypes.func.isRequired
};

export default RecipeList;


/** WEBPACK FOOTER **
 ** ./src/components/collections/RecipeList.js
 **/